import * as React from "react";
import { CheckIcon } from "@radix-ui/react-icons";

import { cn } from "../../lib/utils";

export type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement>;

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(({ className, ...props }, ref) => (
  <span className="relative inline-flex h-4 w-4 items-center justify-center">
    <input
      ref={ref}
      type="checkbox"
      className={cn(
        "peer h-4 w-4 appearance-none rounded border border-slate-200 bg-white ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 checked:border-slate-900 checked:bg-slate-900",
        className,
      )}
      {...props}
    />
    <CheckIcon className="pointer-events-none absolute h-3 w-3 text-white opacity-0 peer-checked:opacity-100" />
  </span>
));
Checkbox.displayName = "Checkbox";

export { Checkbox };
